import './SliderGame.scss';
import React, { useEffect, useState } from 'react';
import Confetti from 'Feature/Confetti/Confetti';
import { Button } from '@lmig/lmds-react-button';

interface ISlider {
  image: IGlassImage;
  'border-color': string;
  'button-in-progress-text': string;
  'button-completed-text': string;
  'load-scrambled': string;
}

const SliderGame = (props: ISlider) => {
  const imageUrl = props.image.Src;
  const borderColor = props['border-color'];
  const buttonInProgressText = props['button-in-progress-text'];
  const buttonCompletedText = props['button-completed-text'];
  const loadScrambled = props['load-scrambled'];

  const SOLVED_TILES = [
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
  ];

  const [tiles, setTiles] = React.useState([
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
  ]);

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      return;
    }
    if (isSolved() && !firstLoad) {
      runConfetti();
    }
    setButtonText(isSolved() ? buttonCompletedText : buttonInProgressText);
  }, [tiles]);

  useEffect(() => {
    if (loadScrambled) {
      shuffle();
    }
  }, [loadScrambled]);

  const [showConfetti, setShowConfetti] = useState<boolean>(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [buttonText, setButtonText] = useState(buttonCompletedText);

  const runConfetti = () => {
    setShowConfetti(true);
    setTimeout(() => setShowConfetti(false), 3000);
  };

  const isSolved = () => {
    for (let row = 0; row < 3; row++) {
      for (let col = 0; col < 3; col++) {
        if (tiles[row][col] !== SOLVED_TILES[row][col]) {
          return false;
        }
      }
    }
    return true;
  };

  const copyTiles = (tiles: number[][]) => tiles.map((row) => [...row]);

  const swapTile = (row1: number, col1: number, row2: number, col2: number) => {
    const newTiles = copyTiles(tiles);
    [newTiles[row1][col1], newTiles[row2][col2]] = [newTiles[row2][col2], newTiles[row1][col1]];
    setTiles(newTiles);
  };

  const shuffle = () => {
    const newTiles = copyTiles(tiles);
    for (let row = 0; row < 3; row++) {
      for (let col = 0; col < 3; col++) {
        const randRow = Math.floor(Math.random() * 3);
        const randCol = Math.floor(Math.random() * 3);

        const temp = newTiles[row][col];
        newTiles[row][col] = newTiles[randRow][randCol];
        newTiles[randRow][randCol] = temp;
      }
    }
    setTiles(newTiles);
  };

  const clickTile = (row: number, col: number) => {
    console.log(`Clicked tile: ${tiles[row][col]}`);
    var tile = tiles[row][col];

    if (tile != 9) {
      if (col < 2 && tiles[row][col + 1] === 9) {
        // Check right
        swapTile(row, col, row, col + 1);
      } else if (col > 0 && tiles[row][col - 1] === 9) {
        // Check left
        swapTile(row, col, row, col - 1);
      } else if (row < 2 && tiles[row + 1][col] === 9) {
        // Check down
        swapTile(row, col, row + 1, col);
      } else if (row > 0 && tiles[row - 1][col] === 9) {
        // Check up
        swapTile(row, col, row - 1, col);
      }
      return;
    }
  };

  return (
    <div className="slider-game" data-theme="evolved">
      {showConfetti && <Confetti />}
      <div id="table" className="table" style={{ border: `1px solid`, borderColor: borderColor }}>
        <div id="row1">
          <div
            id="cell11"
            className={`tile${tiles[0][0]}`}
            onClick={() => clickTile(0, 0)}
            style={tiles[0][0] !== 9 ? { backgroundImage: `url(${imageUrl})` } : { background: '#fff' }}
          ></div>
          <div
            id="cell12"
            className={`tile${tiles[0][1]}`}
            onClick={() => clickTile(0, 1)}
            style={tiles[0][1] !== 9 ? { backgroundImage: `url(${imageUrl})` } : { background: '#fff' }}
          ></div>
          <div
            id="cell13"
            className={`tile${tiles[0][2]}`}
            onClick={() => clickTile(0, 2)}
            style={tiles[0][2] !== 9 ? { backgroundImage: `url(${imageUrl})` } : { background: '#fff' }}
          ></div>
        </div>
        <div id="row2">
          <div
            id="cell21"
            className={`tile${tiles[1][0]}`}
            onClick={() => clickTile(1, 0)}
            style={tiles[1][0] !== 9 ? { backgroundImage: `url(${imageUrl})` } : { background: '#fff' }}
          ></div>
          <div
            id="cell22"
            className={`tile${tiles[1][1]}`}
            onClick={() => clickTile(1, 1)}
            style={tiles[1][1] !== 9 ? { backgroundImage: `url(${imageUrl})` } : { background: '#fff' }}
          ></div>
          <div
            id="cell23"
            className={`tile${tiles[1][2]}`}
            onClick={() => clickTile(1, 2)}
            style={tiles[1][2] !== 9 ? { backgroundImage: `url(${imageUrl})` } : { background: '#fff' }}
          ></div>
        </div>
        <div id="row3">
          <div
            id="cell31"
            className={`tile${tiles[2][0]}`}
            onClick={() => clickTile(2, 0)}
            style={tiles[2][0] !== 9 ? { backgroundImage: `url(${imageUrl})` } : { background: '#fff' }}
          ></div>
          <div
            id="cell32"
            className={`tile${tiles[2][1]}`}
            onClick={() => clickTile(2, 1)}
            style={tiles[2][1] !== 9 ? { backgroundImage: `url(${imageUrl})` } : { background: '#fff' }}
          ></div>
          <div
            id="cell33"
            className={`tile${tiles[2][2]}`}
            onClick={() => clickTile(2, 2)}
            style={tiles[2][2] !== 9 ? { backgroundImage: `url(${imageUrl})` } : { background: '#fff' }}
          ></div>
        </div>
      </div>
      <Button className="button" onClick={shuffle} size="small" variant="secondary">
        {buttonText}
      </Button>
    </div>
  );
};

export default SliderGame;
